import React, {Component} from 'react'
import ReactDOM from 'react-dom';
import { ModalManager, Modal } from './../../index'
import MediaManager from './media-helper/MediaManager.js'
import LinkWithTooltip from '../../tooltip';

const defaultStyles = {
  overlay: {
    backgroundColor : 'rgba(0, 0, 0, 0.8)'
  },
  content: {
    position                : 'fixed',
    top                     : '30px',
    left                    : '30px',
    right                   : '30px',
    bottom                  : '30px',
    overflow                : 'none'
  }
};

class Media extends Component {

  constructor(props) {
    super(props);

    this.state ={
      popIsUp: false,
      image: this.props.input.value,
      type: 'image'
    }
  }

  componentDidMount(){
    const { params } = this.props

    if(params.format != undefined) {
      this.setState({
        type: params.format
      })
    }
  }

  onChangeHandle(event){
    const { input: { value, onChange, name } } = this.props
    onChange( event.target.value );
  }

  handleUploadClick(){
    this.setState({
      popIsUp: true
    })
  }

  handleInsertMedia(item){

    const { input: { value, onChange, name } } = this.props
    onChange( item.path );

    this.setState({
      image: item.path,
      popIsUp: false
    });

    ModalManager.close();
  }

  handleMediaModal(){
    this.setState({
      popIsUp: false
    });
    ModalManager.close();
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.input.value !== this.state.image) {
      this.setState({ image: nextProps.input.value });
    }
  }

  render(){
    const { input: { value, onChange, name }, params } = this.props
    var style = {
      marginBottom: '10px',
      position: 'relative',
    };
    var uploadStyle = {
      display: 'flex',
      width: '100%',
      height: '150px',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      backgroundColor: '#fff',
      borderRadius: '3px',
      overflow: 'hidden',
      marginBottom: '10px'
    }
    var uploadTextStyle = {
      border: '1px solid #D0D3D9',
      borderRadius: '3px',
      fontSize: '12px',
      color: '#D0D3D9',
      padding: '3px 6px'
    }
    var removeBtnStyle = {
      textDecoration: 'none',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      fontSize: '10px',
      color: '#fff',
      padding: '7px 10px',
      transform: 'translateX(-50%)',
      zIndex: 1
    }

    var uploadIconStyle = {
      textDecoration: 'none',
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 1
    }
    var uploadInputStyle = {}
    if(params.hide_preview){
      uploadInputStyle.paddingRight = '22px';
    }
    var imagePath = '';

    if(this.state.image !== '#'){
      if ( this.state.image.startsWith('http') == true ) {
        imagePath = this.state.image;
      } else if( this.state.image != '' ) {
        imagePath = pagebuilder_base + this.state.image;
      }
    }

    let placeholder = params.placeholder || '';

    return(
      <div className="sp-pagebuilder-form-group">
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <div style={style}>

          {
            imagePath == ''
            ?
            !params.hide_preview &&
              <div
                className="sppb-image-input-area"
                style={uploadStyle}
                onClick={(e)=>{
                  e.preventDefault();
                  this.handleUploadClick();
                }}
                >
                <span style={uploadTextStyle}>Upload an image</span>
              </div>
            :
            !params.hide_preview &&
              <div style={{
                position: 'relative',
                height: '150px',
                overflow: 'hidden',
                marginBottom: '10px',
                borderRadius: '3px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fff'
              }}>
                <img src={imagePath} style={{maxWidth: '100%'}} className="field-media-preview" />
                <a style={removeBtnStyle} href="#" onClick={e => { e.preventDefault(); onChange(''); }}><i style={{ fontSize: '14px' }} className="fa fa-trash-o" /> Remove</a>
                <div style={{
                  backgroundImage: 'linear-gradient(-180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.49) 100%)',
                  width: '100%',
                  height: '70px',
                  position: 'absolute',
                  bottom: 0,
                  left: 0
                }}></div>
              </div>
          }
          {
            params.hide_preview &&
            <div style={{position: 'absolute', top: '1px', right: '6px'}}>
              {
                imagePath == ''
                ?
                <a href="#" style={uploadIconStyle} onClick={(e)=>{
                  e.preventDefault();
                  this.handleUploadClick();
                }}><i className="fa fa-upload" /></a>
                :
                <a href="#" style={uploadIconStyle} onClick={(e)=>{
                  e.preventDefault();
                  onChange('');
                }}><i className="fa fa-times" /></a>
              }
            </div>
          }
          <input type="text" value={ this.state.image } placeholder={placeholder} style={uploadInputStyle} className="sp-pagebuilder-form-control sp-pagebuilder-addon-input" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />

        </div>
        {
          this.state.popIsUp == true &&
          <Modal
            openTimeoutMS = { 0 }
            closeTimeoutMS = { 0 }
            overlayClassName = "sp-pagebuilder-media-modal-overlay"
            uniqueId = "sp-pagebuilder-media-modal"
            className = "clearfix"
            style = { defaultStyles }
          >
            <MediaManager
              type={this.state.type}
              onHandleInsertMedia = {this.handleInsertMedia.bind(this)}
              onHandleMediaModal = {this.handleMediaModal.bind(this)}
            />
          </Modal>
        }


      </div>
    )
  }
}

export default Media;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Media.js